<template>
  <v-container>
    <v-form>
    <v-row>
      <v-col cols="4">
        <v-text-field
            v-model="username"
            label="Username"
            required
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
            v-model="password"
            label="Password"
            type="password"
            required
        ></v-text-field>
      </v-col>
    </v-row>
      <v-btn color="primary" @click="signIn">Sign In</v-btn>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "SignIn",
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    signIn() {
      this.$store.dispatch('signIn', {
        username: this.username,
        password: this.password
      }).then(u => {
        this.$router.push('/admin');
      })
    }
  }
}
</script>

<style scoped>

</style>